// extracted by mini-css-extract-plugin
export default {"page":"Error404_page__Db5-x","message":"Error404_message__Q29Id","main":"Error404_main__9VS+2","sub":"Error404_sub__MV4cm"};